<template>
    <section class="practice">
        <div class="row">
             <aside class="col-md-3 col-sm-12 cus-sidebar">
                <practiceSidebar />
            </aside>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" id="content" class="content dailyReport col-md-9 col-sm-12">
                <div class="material-box bg-white">
                    <div class="col-md-12 top-title">
                        <h3>View User</h3>
                    </div>
                    <!-- end page-header -->
                    <div class="col-md-12">
                        <div class="section-container section-with-top-border p-b-10">

                            <div class="panel">
                                <h4 class="m-l-20 m-b-20">{{ user.FirstName }} {{ user.LastName }}</h4>
                               <div class="row">
                                <div class="col-md-4">
                                    <img style="max-width:170px;" alt="User Pic" :src="user.url"
                                        class="img-circle img-responsive">
                            </div>
                            <div class="col-md-8">

                                <table class="table table-user-information">
                                    <tbody>
                                        <tr>
                                            <td>Salutation:</td>
                                            <td>{{ user.Prefix }}</td>
                                        </tr>
                                        <tr>
                                            <td width="100">Name:</td>
                                            <td>{{ user.FirstName }} {{ user.LastName }}</td>
                                        </tr>
                                        <tr>
                                            <td>Status:</td>
                                            <td>{{ user.Status }}</td>
                                        </tr>
                                          <tr>
                                            <td>Password:</td>
                                            <td>{{ user.Password }}</td>
                                        </tr>
                                        <tr>
                                            <td>Email:</td>
                                            <td><a :href="`mailto:${user.Email}`">{{ user.Email }}</a></td>
                                        </tr>

                                    </tbody>
                                </table>
                                <router-link :to="{ name: 'view_dashboard_user' }"
                                    class="btn btn-primary width-100 m-b-10"><i class="fa fa-arrow-left mr-1"></i>Back
                                </router-link>
                                <br>
                            </div>
                               </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import practiceSidebar from "../components/Sidebar.vue";

export default {
    name: "view_user",
    components: {
        practiceSidebar
    },
    data() {
        return {
            isLoading: false,
            loginUser: {},
            user: {},
        }
    },
    methods: {

    },
    mounted() {
        let user = JSON.parse(localStorage.getItem('userDetails'));
        this.loginUser = user;

        if (this.$route.params.user) {
            this.user = this.$route.params.user
        } else {
            this.$router.push({ name: 'view_dashboard_user' });
        }

        if (user.Status == 'DC' || user.Status == 'CA') {
            this.$router.push({ name: 'user_dashboard' });
        }
    },
}

</script>